module.exports = __webpack_public_path__ + "da0f0b216ebb7b7fa41d0238de7675bc.png";